module.exports = __webpack_public_path__ + "img/image-site-tunisie.4bc2773a.jpg";